import React from "react";
import chevronIcon from "../assets/chevron-right.svg";

const finiteInteger = (value) => {
  const parsed = Number(value);
  return Number.isSafeInteger(parsed) ? parsed : null;
};

const finiteDecimal = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export default function NudgeNumber({ value, onChange, min, max, step = 1, allowDecimal = false, disabled = false, list, "aria-label": ariaLabel }) {
  const bounded = (candidate) => {
    let next = candidate;
    if (Number.isFinite(min)) next = Math.max(min, next);
    if (Number.isFinite(max)) next = Math.min(max, next);
    return next;
  };
  const nudge = (direction) => {
    const current = (allowDecimal ? finiteDecimal(value) : finiteInteger(value)) ?? (Number.isFinite(min) ? min : 0);
    onChange(bounded(current + direction * step));
  };
  return (
    <div className="gwNudgeNumber">
      <input
        className="gwInput gwNudgeNumberInput"
        type="text"
        inputMode={allowDecimal ? "decimal" : "numeric"}
        value={value ?? ""}
        onChange={(event) => {
          if (event.target.value === "") {
            onChange(null);
            return;
          }
          if (allowDecimal) {
            if (!/^-?(?:\d+(?:\.\d*)?|\.\d*)$/.test(event.target.value)) return;
            onChange(event.target.value);
            return;
          }
          if (!/^-?\d+$/.test(event.target.value)) return;
          const parsed = finiteInteger(event.target.value);
          if (parsed !== null) onChange(parsed);
        }}
        onBlur={() => {
          const parsed = allowDecimal ? finiteDecimal(value) : finiteInteger(value);
          if (parsed !== null) onChange(bounded(parsed));
        }}
        aria-label={ariaLabel}
        disabled={disabled}
        list={list}
      />
      <div className="gwNudgeNumberButtons">
        <button type="button" onClick={() => nudge(1)} disabled={disabled} tabIndex={-1} aria-label={`Increase ${ariaLabel || "value"}`}>
          <img src={chevronIcon} alt="" className="gwIcon gwNudgeNumberChevron up" />
        </button>
        <button type="button" onClick={() => nudge(-1)} disabled={disabled} tabIndex={-1} aria-label={`Decrease ${ariaLabel || "value"}`}>
          <img src={chevronIcon} alt="" className="gwIcon gwNudgeNumberChevron down" />
        </button>
      </div>
    </div>
  );
}
